import { createContext } from 'react';

export const IframeContext = createContext();
